import type { Db } from "./client";
import { getUserId } from "./client";
import {
  observationCreateSchema,
  type ObservationCreateInput,
} from "./schemas";
import { ValidationError, throwIfPgError } from "./errors";
import type {
  PlantObservationRow,
  PlantObservationInsert,
} from "@garden/types/db";

/** Insert a `plant_observation`. The table is append-only (BEFORE UPDATE/DELETE
 *  triggers from migration 0003 raise on any mutation). To "edit" a typo, the
 *  user logs a correcting observation. */
export async function createObservation(
  client: Db,
  input: ObservationCreateInput,
): Promise<PlantObservationRow> {
  const parsed = observationCreateSchema.safeParse(input);
  if (!parsed.success) {
    throw new ValidationError("invalid observation input", parsed.error);
  }
  const userId = await getUserId(client);
  const { data, error } = await client
    .from("plant_observation")
    .insert({ ...parsed.data, user_id: userId } as PlantObservationInsert) // `as` cast sanctioned at Supabase boundary per spec §5
    .select("*")
    .single();
  throwIfPgError(error);
  return data as PlantObservationRow; // `as` cast sanctioned at Supabase boundary per spec §5
}

export async function listObservationsForPlant(
  client: Db,
  plantId: string,
): Promise<PlantObservationRow[]> {
  const { data, error } = await client
    .from("plant_observation")
    .select("*")
    .eq("plant_id", plantId)
    .order("observation_date", { ascending: false })
    .order("created_at", { ascending: false });
  throwIfPgError(error);
  return (data ?? []) as PlantObservationRow[];
}
